import gql from 'graphql-tag';
import formBlockFieldCustomizeItemFragment from './blockFieldCustomizeItem';

export default gql`
  fragment formPostCustomizeItemDateFragment on FormPostCustomizeItemDate {
    id
    value
    formBlockFieldCustomizeItemId
    formBlockFieldCustomizeItem {
      ...formBlockFieldCustomizeItemFragment
    }
    createdAt
    updatedAt
  }
  ${formBlockFieldCustomizeItemFragment}
`;
